/**
 * @Author: Calvin Green <calvin>
 * @Date:   2022-03-18T14:07:39+02:00
 * @Email:  calvin@diversitude.com
 * @Last modified by:   calvin
 * @Last modified time: 2022-06-22T20:38:47+02:00
 * @Copyright: Diversitude 2022
 */



import { mapState, mapGetters, mapActions } from 'vuex';

export const clientAdminMenuComputed = {
  ...mapState('menuClientAdmin', {
    administration_view: (state) => state.administration_view,
  }),
}

export const clientAdminMenuMethods = mapActions('menuClientAdmin',
[
  'setAdministrationView',
])


export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader,

    show_menu: (state) => state.show_menu,
    show_routes: (state) => state.show_routes,
    menu_type: (state) => state.menu_type,
  })
}
export const layoutMethods = mapActions('layout',
[
  'changeLayoutType', 'changeLayoutWidth',
  'changeLeftSidebarType', 'changeTopbar',
  'changeLoaderValue',
  'updateMenuType',
])

export const userState = {
  ...mapState('user', {
    client_signature: (state) => state.client_signature,
    client_initial: (state) => state.client_initial,
    client_profile: (state) => state.client_profile,
  })
}
export const userMethods = mapActions('user',
[
  'saveClientSignature', 'loadClientSignature', 'saveClientSignature', 'loadClientProfile'
])


export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])


export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])

export const todoComputed = {
  ...mapState('todo', {
    todos: (state) => state.todos
  })
}
export const todoMethods = mapActions('todo', ['fetchTodos']);

//* Facility Admin
export const facilityAdminState = {
  ...mapState('facilityAdmin', {
    facility_view: (state) => state.facility_view,
    location_types: (state) => state.location_types,
    supplier_types: (state) => state.supplier_types,
    folia_locations: (state) => state.folia_locations,
    client_locations: (state) => state.client_locations,
    client_suppliers: (state) => state.client_suppliers,

    all_audits: (state) => state.all_audits,
    client_audit: (state) => state.client_audit,
    selected_audit: (state) => state.selected_audit,
    selected_audit_session_id: (state) => state.selected_audit_session_id,
    selected_audit_session_data: (state) => state.selected_audit_session_data,
  })
}

export const facilityAdminMethods = mapActions('facilityAdmin', ['setFacilityView', 'loadLocationTypes', 'loadClientLocations', 'loadClientSuppliers', 'saveClientLocation', 'saveClientSupplier', 'linkLocationSupplier',
'loadFoliaLocations', 'getSupplierSLAPreviewLink', 'deleteSupplierSLA', 'deleteClientSupplier', 'loadSupplierTypes',
'clearAuditData', 'getAvailableAudits', 'getClientAudit', 'setSelectedAuditID',
'startNewAuditSession', 'deleteAuditSession' ,'setSelectedSessionID', 'getClientAuditSessionData',
'saveAuditSessionForm', 'deleteEvidenceFile', 'endAuditSession', 'deleteClientLocation'

]);

//* Facility Client Admin
/*export const facilityClientAdminState = {
  ...mapState('facilityClientAdmin', {
    facility_view: (state) => state.facility_view,
  })
}
export const facilityClientAdminMethods = mapActions('facilityClientAdmin', ['setFacilityView']);*/



export const clientAdminState = {
  ...mapState('clientAdmin', {
    core_data: (state) => state.core_data,
    user_levels: (state) => state.user_levels,
    level_types: (state) => state.level_types,
    users_in_level: (state) => state.users_in_level,
    level_id: (state) => state.level_id,
    all_users: (state) => state.all_users,
    user_profile: (state) => state.user_profile,
    audit_logs: (state) => state.audit_logs,
  })
}
export const clientAdminMethods = mapActions('clientAdmin', ['loadCoreData', 'clearCoreData',
'loadLevels', 'loadLevelTypes', 'saveLevel', 'deleteLevel', 'loadLevelUsers', 'clearLevelUsers',
'saveUserToLevel', 'deleteUser', 'saveLevelLead', 'removeUserFromSelectedLevel',
'downloadPersonnelDocument', 'downloadPersonnelDocuments', 'addUserToSelectedLevel',
'getLoggedInUserProfile', 'requestSopDistribution', 'loadAuditLogs', 'resetUserCredentials'
]);


export const licenseAppState = {
  ...mapState('licenseApp', {
    app_data: (state) => state.app_data,
    step_data: (state) => state.step_data,
  })
}
export const licenseAppMethods = mapActions('licenseApp', ['loadAppData',
'loadStepData', 'saveFormData',
'requestStepApproval', 'getDownloadLink', 'saveComment', 'markAction', 'deleteComment']);


export const ccbAdminState = {
  ...mapState('ccbAdmin', {
    admin_users: (state) => state.admin_users,
    clients: (state) => state.clients,
    client_data: (state) => state.client_data,
    client_step_data: (state) => state.client_step_data,
    client_levels: (state) => state.client_levels,
    module_types: (state) => state.module_types,
  })
}
export const ccbAdminMethods = mapActions('ccbAdmin',
['loadAdminUsers', 'loadClients', 'addClient', 'loadClientData', 'loadClientLevels', 'addTask', 'loadModuleTypes', 'addClientAudit',
 'loadClientStepData', 'saveAdminUser', 'addComment', 'markAsRead', 'deleteStepAction', 'validateStep', 'distributeAllSOPs']);


//* shared store for ccb_admin, admin and client
export const sopState = {
  ...mapState('sop', {
    sops: (state) => state.sops,
    sop_data: (state) => state.sop_data,
    sop_groups: (state) => state.sop_groups,
    selected_sop_group: (state) => state.selected_sop_group,
    notifications: (state) => state.notifications,
    context_menu_id: (state) => state.context_menu_id,
    action_id: (state) => state.action_id,

    is_loading_documents: (state) => state.is_loading_documents,
    sop_stats: (state) => state.sop_stats,
    workflows: (state) => state.workflows,
    assignable_sops: (state) => state.assignable_sops,
    active_job_data: (state) => state.active_job_data,

    client_sop_data: (state) => state.client_sop_data,
    all_attachments: (state) => state.all_attachments,
    distribution_clients: (state) => state.distribution_clients,
    distribution_sop: (state) => state.distribution_sop,
    modules: (state) => state.modules,
  })
}
export const sopMethods = mapActions('sop',
  [
    //data
    'loadSops',//
    'previewSop',//
    'selectSopGroup',//
    'loadSopGroups', //
    'clearSopStore',//
    'loadSopData',//
    'getSopLink',//
    'saveSopType',//
    'loadNotifications', //
    'deleteSopType', //
    'saveSopRevision', //
    'saveSopGroup', //
    'deleteSopGroup', //
    'saveSopAttachment', //
    'deleteSopAttachment', //
    'clearSopsFromGroup', //
    'setSopFromMenu', //
    'getPreviewB64',//
    'uploadSignedSop',//
    'setDocumentFlag',//
    'distributeSOP', //
    'approveSopDistribution', //
    'setContextMenuID',//
    'setActionItemID',//
    'updateSopDocumentMode',//
    'loadWorkflows', //
    'loadAssignableSops', //
    'assignSopToWorkflow', //
    'unassignSopToWorkflow', //
    'setActiveJobInfo', //
    'clearAll', //
    'pushRevisionToRevisionArray',
    'toggleSopOverride',
    'saveSopHeader',
    'saveSopRevisionLog',
    'saveSopDistributionLog',
    'approveSopRevision',
    'loadSopStats',
    'loadClientSop',
    'publishTemplateSop',
    'loadModules',
    'saveModule',
    'deleteModule',
  ]
);



 export const sopAdminState = {//* CCB ADMIN
  ...mapState('sopAdmin', {
    sop_groups: (state) => state.sop_groups,
    selected_sop_group: (state) => state.selected_sop_group,
    sops: (state) => state.sops,
    sop_data: (state) => state.sop_data,
    all_attachments: (state) => state.all_attachments,
    context_menu_id: (state) => state.context_menu_id,
    distribution_clients: (state) => state.distribution_clients,
    distribution_sop: (state) => state.distribution_sop,
    sop_stats: (state) => state.sop_stats,
    client_sop_data: (state) => state.client_sop_data,
    notifications: (state) => state.notifications,
  })
}
export const sopAdminMethods = mapActions('sopAdmin', ['clearSopStore', 'setContextMenuID', 'loadSopGroups', 'loadDistributionClients',
'saveSopGroup', 'deleteSopGroup', 'saveSopType', 'deleteSopType', 'selectSopGroup', 'getAllAttachments', 'previewSop', 'getCachedSopPreview', 'distributeSop', 'duplicateSopAttachment',
'saveSopAttachment', 'deleteSopAttachment',
'loadSops', 'loadSopData', 'loadSopForDistribution', 'saveSopRevision', 'publishSop',
'loadSopStats', 'loadClientSop', 'saveClientSopRevision', 'loadNotifications',
'getPreviewB64'
]);

export const sopClientAdminState = {
  ...mapState('sopClientAdmin', {
    sops: (state) => state.sops,
    sop_data: (state) => state.sop_data,
    sop_groups: (state) => state.sop_groups,
    notifications: (state) => state.notifications,
    selected_sop_group: (state) => state.selected_sop_group,
    context_menu_id: (state) => state.context_menu_id,
    sop_stats: (state) => state.sop_stats,
    workflows: (state) => state.workflows,
    assignable_sops: (state) => state.assignable_sops,
    active_job_data: (state) => state.active_job_data
  })
}
export const sopClientAdminMethods = mapActions('sopClientAdmin',
  [
    'loadSops', 'loadNotifications', 'loadSopGroups', 'deleteSopGroup',
    'saveSopGroup', 'selectSopGroup',
    'saveSopType', 'deleteSopType',
    'clearSopStore', 'loadSopData', 'approveSopRevision', 'saveSopRevision',
    'previewSop', 'getPreviewB64', 'uploadSignedSop',
    'setContextMenuID', 'setSopFromMenu', 'setDocumentFlag', 'distributeSOP',
    'approveSopDistribution', 'setActiveJobInfo', 'deleteSopAttachment',
    'loadWorkflows', 'assignSopToWorkflow','unassignSopToWorkflow', 'loadAssignableSops', 'clearSopsFromGroup'
  ]);

export const sopClientState = {
  ...mapState('sopClient', {
    sops: (state) => state.sops,
    sop_data: (state) => state.sop_data,
    sop_groups: (state) => state.sop_groups,
    selected_sop_group: (state) => state.selected_sop_group,
    notifications: (state) => state.notifications,
    context_menu_id: (state) => state.context_menu_id,
    action_id: (state) => state.action_id,
  })
}
export const sopClientMethods = mapActions('sopClient',
  [
    'loadSopGroups', 'selectSopGroup', 'loadSops',
    'previewSop', 'clearSopStore', 'loadSopData', 'getSopLink',
    'loadNotifications', 'getPreviewB64', 'uploadSignedSop', 'setDocumentFlag',
    'setContextMenuID', 'setActionItemID',
  ]);
